// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_MovimentacaoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for registrarMovimentacao() — POST /caixa/movimentacao
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_MovimentacaoResponseDados {
id?: number
caixa_abertura_id?: number
tipo?: string
forma_pagamento?: string
valor?: number
entrada_saida?: string
saldo_antes?: number
saldo_depois?: number
origem?: string
origem_id?: number
observacao?: string
conferido?: number
operador_id?: number
created_at?: string
}

export type Caixa_MovimentacaoResponse = ApiResponse<Caixa_MovimentacaoResponseDados>;

registerResponseContract('Caixa_MovimentacaoResponse', {
  id:                { type: 'number',  required: false },
  caixa_abertura_id: { type: 'number',  required: false },
  tipo:              { type: 'string',  required: false },
  forma_pagamento:   { type: 'string',  required: false },
  valor:             { type: 'number',  required: false },
  entrada_saida:     { type: 'string',  required: false },
  saldo_antes:       { type: 'number',  required: false },
  saldo_depois:      { type: 'number',  required: false },
  origem:            { type: 'string',  required: false },
  origem_id:         { type: 'number',  required: false },
  observacao:        { type: 'string',  required: false },
  conferido:         { type: 'number',  required: false },
  operador_id:       { type: 'number',  required: false },
  created_at:        { type: 'string',  required: false },
})
